import React, { useEffect } from "react";
import { MusicPracticeFormStyled } from "./styled";
import { Controller } from "react-hook-form";
import {
  FILTER_PRACTICE_ROOM_END_TIME,
  IS_IN_OPTIONS,
  IS_PRACTICE_ROOM_CLOSED_DAY,
  PRACTICE_ROOM_START_TIME_OPTIONS,
} from "utils/functions/roomBookingTime";
import { Inputs } from "components";

// กฎเวลาเหมือนฝั่งลูกค้า: 09.00-17.30 ขั้นต่ำ 30 นาที / ปิดวันจันทร์ / ห้ามวันย้อนหลัง
const MusicPracticeForm = ({
  control,
  errors,
  eventStartTime,
  eventEndTime,
  setValue,
  practiceRoomList,
}) => {
  const endTimeOptions = FILTER_PRACTICE_ROOM_END_TIME(eventStartTime);

  // เปลี่ยนเวลาเริ่มแล้วเวลาจบเดิมสั้นกว่าขั้นต่ำ ล้างให้เลือกใหม่
  useEffect(() => {
    if (!IS_IN_OPTIONS(eventEndTime, endTimeOptions)) {
      setValue("event_end_time", "");
    }
  }, [eventStartTime, eventEndTime]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MusicPracticeFormStyled>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              {...field}
              label={"ชื่อ"}
              // placeholder={t('test')}
              errors={errors.booker_first_name?.message}
            />
          )}
          name="booker_first_name"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              {...field}
              label={"นามสกุล"}
              // placeholder={t('test')}
              errors={errors.booker_last_name?.message}
            />
          )}
          name="booker_last_name"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              {...field}
              label={"เบอร์โทรศัพท์"}
              // placeholder={t('test')}
              errors={errors.booker_phone?.message}
            />
          )}
          name="booker_phone"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              {...field}
              label={"อีเมล"}
              // placeholder={t('test')}
              errors={errors.booker_email?.message}
            />
          )}
          name="booker_email"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Dropdown
              {...field}
              label={"Practice Room"}
              options={practiceRoomList}
              // placeholder={t('test')}
              errors={errors.room_ref_id?.message}
            />
          )}
          name="room_ref_id"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.DateTime
              {...field}
              minDate={new Date()}
              // ห้องซ้อมปิดวันจันทร์ เลือกไม่ได้
              filterDate={(date) => !IS_PRACTICE_ROOM_CLOSED_DAY(date)}
              label={"เลือกวัน"}
              // placeholder={t('test')}
              errors={errors.booking_date?.message}
            />
          )}
          name="booking_date"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Dropdown
              {...field}
              label={"เลือกช่วงเวลาเริ่มต้น"}
              // placeholder={t('test')}
              options={PRACTICE_ROOM_START_TIME_OPTIONS}
              errors={errors.event_start_time?.message}
            />
          )}
          name="event_start_time"
          defaultValue=""
        />
      </div>
      <div className="input_wrap">
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Dropdown
              {...field}
              label={"เลือกช่วงเวลาสิ้นสุด"}
              options={endTimeOptions}
              // placeholder={t('test')}
              errors={errors.event_end_time?.message}
            />
          )}
          name="event_end_time"
          defaultValue=""
        />
        <div className="time_rec_label">* ระยะเวลาจองขั้นต่ำ 30 นาที</div>
      </div>
    </MusicPracticeFormStyled>
  );
};

MusicPracticeForm.propTypes = {};

export default MusicPracticeForm;
